<!-- Accroding -->
<div class="row mt-expButton">
  <div class="col-12">
    <div class="checkout-action-buttons">
      <div *ngIf="isToggle" (click)="isToggle = !isToggle" class="toggle-align">
        <a (click)="accordion.openAll()"
          ><i class="material-icons"> keyboard_arrow_down </i>{{ "quoteCheckout.loggedInExp" | cxTranslate }}</a
        >
      </div>
      <div
        *ngIf="!isToggle"
        (click)="isToggle = !isToggle"
        class="toggle-align"
      >
        <a (click)="accordion.closeAll()"
          ><i class="material-icons"> keyboard_arrow_up </i>{{ "quoteCheckout.loggedInCol" | cxTranslate }}</a
        >
      </div>
    </div>
  </div>
</div>
<!-- #docregion multi -->
<mat-accordion class="checkout-headers-align" multi>
  <!-- #enddocregion multi -->
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ "quoteCheckout.guestCheckoutSold" | cxTranslate }}</mat-panel-title>
      <mat-panel-description> </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="section-container">{{ "quoteCheckout.guestCheckoutSold2" | cxTranslate }}</div>
    <div *ngIf="user$ | async as user">
      <div [formGroup]="loggedInSoldToAddressForm">
        <address
          [ngClass]="
            cartData?.quoteCartType == QuoteStatus.EDIT ? 'disabled' : ''
          "
        >
          <div>{{ cartData?.billToAddress?.companyName }}</div>
          <div>
            {{ cartData?.billToAddress?.line1
            }}{{ cartData?.billToAddress?.line1 ? "," : "" }}
            {{ cartData?.billToAddress?.line2
            }}{{ cartData?.billToAddress?.line2 ? "," : "" }}
          </div>
          <div>
            {{ cartData?.billToAddress?.town
            }}{{ cartData?.billToAddress?.town ? "," : "" }}
          </div>
          <div>
            {{ cartData?.billToAddress?.region?.name
            }}{{ cartData?.billToAddress?.region?.name ? "," : "" }}
          </div>
          <div>
            {{ cartData?.billToAddress?.country?.name
            }}{{ cartData?.billToAddress?.country?.name ? "," : "" }}
          </div>
          <div>
            {{ cartData?.billToAddress?.postalCode }}
          </div>
        </address>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title> {{ "quoteCheckout.guestCheckoutShip" | cxTranslate }}</mat-panel-title>
      <mat-panel-description> </mat-panel-description>
    </mat-expansion-panel-header>
    <vs-ship-to-address
      [selectedAddress]="cartData?.deliveryAddress"
      (deliveryAddressUpdate)="deliveryAddressUpdate($event)"
      [quoteCartType]="cartData?.quoteCartType"
    ></vs-ship-to-address>
  </mat-expansion-panel>

  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ "quoteCheckout.guestCheckoutDetail" | cxTranslate }}</mat-panel-title>
      <mat-panel-description> </mat-panel-description>
    </mat-expansion-panel-header>

    <vs-end-customer-address
      [orderType]="orderType"
      [isSubmitted]="isSubmitted"
      (endCountryData)="endCountryData($event)"
      [selectedAddress]="cartData?.endUserAddress || cartData?.deliveryAddress"
      [endUserIndustryName]="cartData?.endUserIndustry"
      [rfqTypes]="rfqTypes"
      [orderChanged]="orderChanged"
      [quoteCartType]="cartData?.quoteCartType"
      [deliveryAddress]="cartData?.deliveryAddress"
      (endCustomerAddressUpdate)="endCustomerAddressUpdate($event)"
      (endUserIndustryUpdate)="endUserIndustryUpdate($event)"
    ></vs-end-customer-address>
  </mat-expansion-panel>

  <div class="section-container">
    <div class="row">
      <div class="heading-text mt-43">
        <span class="require">* </span>{{ "quoteCheckout.guestCheckoutQuestionnaire" | cxTranslate }}
      </div>
    </div>
    <hr />
    <vs-compliance-questions
      [isSubmitted]="isSubmitted"
      [complienceQuestions]="complienceQuestions"
      [loggedIn]="loggedIn"
      [warningFlagText]="warningFlagText"
      (warningFlagTextUpdate)="warningFlagTextUpdate($event)"
      (complienceQuestionsUpdates)="complienceQuestionsUpdates($event)"
    ></vs-compliance-questions>
  </div>

  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title> {{ "quoteCheckout.guestCheckoutNotifications" | cxTranslate }}</mat-panel-title>
      <mat-panel-description> </mat-panel-description>
    </mat-expansion-panel-header>
    <div [formGroup]="loggedInNotificationsForm">
      <div class="mt-question">
        <div class="col-3 padding-left-0">
          <div class="vs-text-field">
            <label
              ><span class="require">* </span>{{ "quoteCheckout.guestCheckoutEmail" | cxTranslate }}</label
            >
            <input
              type="text" [readonly]="readOnly"
              formControlName="quoteAcknowledge"
              class="quoteAcknowledge"
              placeholder='{{ "quoteCheckout.guestCheckoutEmail" | cxTranslate }}'
              [ngClass]="
                (this.quoteAcknowledge.invalid &&
                  (this.quoteAcknowledge.dirty ||
                    this.quoteAcknowledge.touched)) ||
                (this.isSubmitted && !this.quoteAcknowledge.valid) ||
                (this.isSubmitted &&
                  (this.cartData?.notificationEmail === '' ||
                    !this.cartData?.notificationEmail) &&
                  this.cartData?.quoteCartType == QuoteStatus.EDIT)
                  ? 'error'
                  : ''
              "
            />
            <label
              *ngIf="
                (this.quoteAcknowledge.invalid &&
                  (this.quoteAcknowledge.dirty ||
                    this.quoteAcknowledge.touched)) ||
                (this.isSubmitted && !this.quoteAcknowledge.valid) ||
                (this.isSubmitted &&
                  (this.cartData?.notificationEmail === '' ||
                    !this.cartData?.notificationEmail) &&
                  this.cartData?.quoteCartType == QuoteStatus.EDIT)
              "
              class="error"
              >{{ "quoteCheckout.guestCheckoutEmail2" | cxTranslate }}</label
            >
          </div>
        </div>
      </div>
    </div>
    <div class="mt-question">
      <vs-notification-attachments
        (updateFiles)="updateFiles($event)"
        [attachments]="cartData?.attachments"
      ></vs-notification-attachments>
    </div>
  </mat-expansion-panel>
</mat-accordion>
